export const GENERIC_ERROR = "Unknown error";

export function getTryCatchErrorMessage(e?: unknown): string {
  if (
    e &&
    typeof e === "object" &&
    "message" in e &&
    typeof e.message === "string"
  ) {
    return e.message;
  } else if (typeof e === "string") {
    return e;
  } else {
    return GENERIC_ERROR;
  }
}
